import React, { useState, useEffect, useContext, useMemo } from 'react'
import styles from './discount-code.module.scss'
import { useTable, usePagination, useFilters, useSortBy } from 'react-table'
import { useLocation, useHistory } from 'react-router-dom'
import { baseApiURL } from 'src/utils/utils'
import { DispatchContext, StateContext } from '../../AppContext'
import Header from 'src/components/header/Header'
import Button from 'src/components/button/Button'
import { IState } from 'src/Interface'
import axios from 'axios'
import { toast } from 'react-toastify'
import Footer from 'src/components/footer/Footer'
import Table from 'src/components/table/Table'
import SubHeader from 'src/components/subHeader/SubHeader'
import { format } from 'date-fns'
import useCancellablePromise from 'src/utils/useCancellablePromise'
// import { toast } from 'react-toastify'


interface IValues {
  marketingOptedUsers: number
  discountCodesRedeemed: number
 
}

const DiscountCode: React.FC = () => {

  const [loading, setLoading] = useState(true)
  const dispatch: React.Dispatch<any> = useContext(DispatchContext)
  const state: IState = useContext(StateContext)
  const history = useHistory()
  const location: any = useLocation()
  const { cancellablePromise } = useCancellablePromise()
  const [values, setValues] = useState<IValues>({
    marketingOptedUsers: 0,
    discountCodesRedeemed: 0
  })

  useEffect(() => {
    if (state.user.accessToken) {
      setLoading(true)
      cancellablePromise(axios(`${baseApiURL()}/dawa/zip_codes/`,
        {
          headers: {
            Authorization:
              `Bearer ${state.user.accessToken}`
          }
        })
        .then((result) => {
          dispatch({ type: 'SET_COORDINATES', coordinates: result.data })
          setLoading(false)
        }))
    }
  }, [dispatch, state.user.accessToken, cancellablePromise])

  const data = useMemo(() => state.discountCodes, [state.discountCodes])
  const columns = useMemo(() => {
    const statuses = {
      PENDING: {
        label: 'Afventer',
        style: 'status--blue'
      },
      LOCKED_ACTIVE: {
        label: 'Aktiv',
        style: 'status--green'
      },
      ACTIVE: {
        label: 'Aktiv',
        style: 'status--green'
      },
      EXPIRED: {
        label: 'Udløbet',
        style: 'status--red'
      },
      CANCELLED: {
        label: 'Udløbet',
        style: 'status--red'
      },
    }

    return [
      {
        Header: 'Oprettet',
        accessor: ({ createdAt, status }: any) => <span className={status === 'EXPIRED' || status === 'CANCELLED' ? 'tw-opacity-50' : ''}>{format(new Date(createdAt), 'dd/MM/yyyy')}</span>
      },
      {
        Header: 'Rabatkode',
        accessor: ({ code, status }: any) => <span className={status === 'EXPIRED' || status === 'CANCELLED' ? 'tw-opacity-50' : ''}>{code}</span>
      },
      {
        Header: 'Rabat',
        accessor: ({ percentage, status }: any) => <span className={status === 'EXPIRED' || status === 'CANCELLED' ? 'tw-opacity-50' : ''}>{percentage}</span>
      },
      {
        Header: 'Varighed',
        accessor: ({ startDate, expiryDate, status }: any) => <p className={`tw-flex tw-items-center ${status === 'EXPIRED' || status === 'CANCELLED' ? 'tw-opacity-50' : ''}`}>
          <span>{format(new Date(startDate), 'dd/MM/yyyy')}</span>
          {expiryDate &&
            <>  <svg xmlns="http://www.w3.org/2000/svg" className="tw-h-5 tw-w-5 tw-mx-2 fill-gray" viewBox="0 0 20 20">
              <path fillRule="evenodd" d="M10.293 5.293a1 1 0 011.414 0l4 4a1 1 0 010 1.414l-4 4a1 1 0 01-1.414-1.414L12.586 11H5a1 1 0 110-2h7.586l-2.293-2.293a1 1 0 010-1.414z" clipRule="evenodd" />
            </svg>
              <span>{format(new Date(expiryDate), 'dd/MM/yyyy')}</span>
            </>}
        </p>

      },
      {
        Header: 'Fra lokation',
        accessor: ({ zipCodesFrom, status }: any) => (
          !zipCodesFrom.length ?
            <span className={status === 'EXPIRED' || status === 'CANCELLED' ? 'tw-opacity-50' : ''}>Alle postnumre</span> :
            <p className={status === 'EXPIRED' || status === 'CANCELLED' ? 'tw-opacity-50' : ''}>
              {zipCodesFrom.map((zipCode, i) => {
                if (i <= 8) {
                  return `${zipCode}${i <= 7 && (zipCodesFrom.length > 0 && i !== zipCodesFrom.length - 1) ? ', ' : ''}`
                }
              })}
              {zipCodesFrom.length > 8 && <span>...</span>}
            </p>
        )
      },
      {
        Header: 'Til lokation',
        accessor: ({ zipCodesTo, status }: any) => (
          !zipCodesTo.length ?
            <span className={status === 'EXPIRED' || status === 'CANCELLED' ? 'tw-opacity-50' : ''}>Alle postnumre</span> :
            <p className={status === 'EXPIRED' || status === 'CANCELLED' ? 'tw-opacity-50' : ''}>
              {zipCodesTo.map((zipCode, i) => {
                if (i <= 8) {
                  return `${zipCode}${i <= 7 && (zipCodesTo.length > 0 && i !== zipCodesTo.length - 1) ? ', ' : ''}`
                }
              })}
              {zipCodesTo.length > 8 && <span>...</span>}
            </p>
        )
      },
      {
        Header: 'Status',
        accessor: 'status',
        Cell: ({ value }: any) => {
          return <span className={`status ${statuses[value].style}`}>{statuses[value].label}</span>
        }
      }
    ]
  }, [])

  const {
    getTableProps,
    getTableBodyProps,
    headerGroups,
    canNextPage,
    canPreviousPage,
    gotoPage,
    pageOptions,
    previousPage,
    state: pageState,
    nextPage,
    page,
    prepareRow,
  } = useTable({
    columns,
    data,
    autoResetPage: false
  }, useFilters, useSortBy, usePagination)

  useEffect(() => {
    if (state.user.accessToken) {
      const tempValues=values
      cancellablePromise(axios(`${baseApiURL()}/discount_codes`, {
        headers: {
          Authorization:
            `Bearer ${state.user.accessToken}`
        }
      }).then((result) => {
        setLoading(false)
        dispatch({ type: 'SET_DISCOUNT_CODES', discountCodes: result.data })
      }).catch((err) => {
        toast(err.response.data.message)
        setLoading(false)
      }))

      cancellablePromise(axios(`${baseApiURL()}/discount_codes/redeem_counts`, {
        headers: {
          Authorization:
            `Bearer ${state.user.accessToken}`
        }
      }).then((result) => {
        setLoading(false)
        setValues({...tempValues,discountCodesRedeemed:result.data?.count})
        tempValues.discountCodesRedeemed=result.data?.count
      }).catch((err) => {
        toast(err.response.data.message)
        setLoading(false)
      })) 
      cancellablePromise(axios(`${baseApiURL()}/mobile_users/MARKETING/count`, {
        headers: {
          Authorization:
            `Bearer ${state.user.accessToken}`
        }
      }).then((result) => {
        setLoading(false)
        setValues({...tempValues,marketingOptedUsers:result.data?.count})
        tempValues.marketingOptedUsers=result.data?.count

      }).catch((err) => {
        toast(err.response.data.message)
        setLoading(false)
      }))
    }
  }, [dispatch, state.user.accessToken, cancellablePromise])


  if (state.user.role && state.user.role !== 'DanTaxiAdmin') {
    history.push('/order')
    return null
  }

  return (
    <>
      <Header />
      <SubHeader loading={loading} backPath={'/settings'} title={
        <>
          <svg className='arrow-icon' xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M10 19l-7-7m0 0l7-7m-7 7h18" />
          </svg> <span className='color-gray tw-font-normal'>Indstillinger</span> <span className='tw-mx-3 color-gray tw-font-normal'>/</span>
          <span className='text-black text-bold'>Rabatkoder</span>
        </>}>

        <span className={styles.headingBox}>
          <span className={`${styles.boxDescription}`}>Discount Codes Redeemed</span> 
          <span className={`tw-ml-5 ${styles.headingBoxTitle}`}>{values.discountCodesRedeemed}</span>
        </span>  

        <span className={styles.headingBox}>
          <span className={`${styles.boxDescription}`}>Marketing Opted Users</span> 
          <span className={`tw-ml-5 ${styles.headingBoxTitle}`}>{values.marketingOptedUsers}</span>
        </span>

        <Button modifiers='tw-ml-5' type='primary' label='Opret rabatkode'
          iconLeft={<svg xmlns="http://www.w3.org/2000/svg" className="tw-h-5 tw-w-5" viewBox="0 0 20 20" fill="currentColor">
            <path fillRule="evenodd" d="M10 3a1 1 0 011 1v5h5a1 1 0 110 2h-5v5a1 1 0 11-2 0v-5H4a1 1 0 110-2h5V4a1 1 0 011-1z" clipRule="evenodd" />
          </svg>} handleClick={() => dispatch({ showModal: true, type: 'SHOW_MODAL', modalType: 'addDiscountCode' })} />
      </SubHeader>
      <main className='container'>
        <Table
          getTableBodyProps={getTableBodyProps}
          getTableProps={getTableProps}
          prepareRow={prepareRow}
          loading={loading}
          page={page}
          handleClick={(id) => dispatch({ type: 'SHOW_ASIDE', asideType: 'DiscountCodeDetails', show: true, discountCodeId: id })}
          headerGroups={headerGroups}
          type='discountCodes'
          state={{ background: location }}

        />
      </main>
      <Footer
        pageState={pageState}
        canNextPage={canNextPage}
        nextPage={nextPage}
        canPreviousPage={canPreviousPage}
        paginationLabel='rabatkoder'
        loading={loading}
        page={page}
        gotoPage={gotoPage}
        previousPage={previousPage}
        pageOptions={pageOptions}
        itemsLength={state.discountCodes.length}
      />
    </>
  )
}

export default DiscountCode